import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { ScrollyArticle } from '../components/ScrollyPage/ScrollyArticle';

const Guide = lazy(() => import('../components/ScrollyPage/Guide'));

export const Route = createFileRoute('/om/guide')({
    component: Index,
});

function Index() {
    return (
        <ScrollyArticle>
            <Suspense fallback={null}>
                <Guide />
            </Suspense>
        </ScrollyArticle>
    );
}
